import { BidiModule } from "@angular/cdk/bidi";
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { NzOutletModule } from "ng-zorro-antd/core/outlet";
import { UiIconModule } from "../icon/icon.module";
import { UiTooltipModule } from "../tooltip/tooltip.module";
import { UiTextCopyComponent } from "./components/text-copy/text-copy.component";
import { UiTextEditComponent } from "./components/text-edit/text-edit.component";
import { UiTypographyComponent } from "./typography.component";

@NgModule({
  imports: [CommonModule, BidiModule, NzOutletModule, UiIconModule, UiTooltipModule],
  declarations: [UiTypographyComponent, UiTextEditComponent, UiTextCopyComponent],
  exports: [UiTypographyComponent, UiTextEditComponent, UiTextCopyComponent],
})
export class UiTypographyModule {}
